import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "../../hooks/useTranslation";

export default function CartOrDashboardButton({ user }) {
  const { t } = useTranslation();
  
  return (
    <Button
     sx={{
        // borderRadius: "50px",
        height: "60px",
      }}
      href={user ? "/dashboard" : "/order"}
      variant="primaryButton"
    >
      {user ? t('dashboard') : t('viewMenu')}
    </Button>
  );
}